var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ELSLoggingService } from 'components/common';
import { FULFILLED_STATUS } from 'constants/app.constant';
import { facadeApi, perFacadeApi } from 'helpers/api.helper';
import { getStudentUserFullName, getTimeZone } from 'helpers/app.helper';
import { first, isNil, keyBy, mapValues } from 'lodash';
import { SystemType } from 'models';
import moment from 'moment';
import { ASSIGNMENT_GRADES_TYPES, ASSIGNMENT_TYPE_GROUPS, ASSIGNMENT_TYPES, DATE_FORMATS, eaqAssignmentConstants, eaqConstants, NO_DUE_DATE, VALUE_NA } from 'reports/cw/constants/report.constant';
import { fetchAllCourseAggregations } from 'reports/ps/services/ps.service';
import { fetchCrosswalkUser } from 'services/user-management.service';
import { remapCourseAggregate, remapCourseSection } from '../helpers/report.helper';
var asTimestring = function (seconds) {
    var minutes = Math.round(seconds / 60);
    var minutesPastHour = minutes % 60;
    var hours = Math.floor(minutes / 60);
    // Format: hours, minutes past the hour, seconds past the minute
    if (hours > 0) {
        return "".concat(hours, "h ").concat(minutesPastHour, "min");
    }
    if (minutesPastHour > 0) {
        return "".concat(minutesPastHour, "min");
    }
    return VALUE_NA;
};
var asTimestringFormated = function (seconds) {
    var secondsPastMinute = seconds % 60;
    var minutes = Math.floor(seconds / 60);
    var minutesPastHour = minutes % 60;
    var hours = Math.floor(minutes / 60);
    // Format: hours, minutes past the hour, seconds past the minute
    var formattedDisplay = function (number, unit) {
        return number > 0 ? "".concat(number).concat(unit) : '';
    };
    if (hours > 0) {
        return "".concat(formattedDisplay(hours, 'h'), " ").concat(formattedDisplay(minutesPastHour, 'min'), " ").concat(formattedDisplay(secondsPastMinute, 's')).trim();
    }
    if (minutesPastHour > 0) {
        return "".concat(formattedDisplay(minutesPastHour, 'min'), " ").concat(formattedDisplay(secondsPastMinute, 's')).trim();
    }
    return "".concat(secondsPastMinute, "s");
};
var durationAsTimestring = function (duration) {
    var seconds = Math.floor(duration.seconds());
    var minutes = duration.minutes();
    var hours = Math.floor(duration.asHours());
    // Format: hours, minutes, seconds
    if (hours > 0) {
        return "".concat(hours, "h ").concat(minutes, "m ").concat(seconds, "s");
    }
    if (minutes > 0) {
        return "".concat(minutes, "m ").concat(seconds, "s");
    }
    return "".concat(seconds, "s");
};
var asTimestamp = function (str, stamp) {
    return moment(stamp).isValid() ? moment(stamp).format(DATE_FORMATS.TIMESTAMP) : VALUE_NA;
};
// PT-12M3S ==> -PT12M3S
var convertNegativeDuration = function (duration) {
    if (duration.includes('-')) {
        return "-".concat(duration.replace('-', ''));
    }
    return duration;
};
// 12 ==> "+12" && -12 => "-12"
var displayNumberWithSign = function (num) {
    return num > 0 ? "+".concat(num.toFixed(2)) : "".concat(num.toFixed(2));
};
var getAssignmentTypeTranslateText = function (assignmentType) {
    switch (assignmentType) {
        case eaqConstants.assignmentType.mastery:
            return 'ASSIGNMENTS_GOAL';
        case eaqConstants.assignmentType.standard:
            return 'CUSTOM';
        case eaqConstants.assignmentType.quizByQuestion:
            return 'ASSIGNMENTS_CUSTOM_BY_QUESTION';
        default:
            return '';
    }
};
var getAvgStudentsAchievedMastery = function (assignmentStatus) {
    var completed = assignmentStatus.completed;
    var totalStudents = Object.values(assignmentStatus).reduce(function (total, currentItem) { return total + currentItem; }, 0);
    var avgStudentsAchievedMastery = completed / totalStudents || 0;
    return {
        value: "".concat(Math.floor(avgStudentsAchievedMastery * 100), "%"),
        sort: avgStudentsAchievedMastery
    };
};
var getGradeTypeDisplayName = function (assignmentGradeType) {
    switch (assignmentGradeType) {
        case eaqAssignmentConstants.labels.assignmentGrades.notGraded:
            return 'GRADE_TYPE_NOT_GRADED';
        case eaqAssignmentConstants.labels.assignmentGrades.graded:
            return 'GRADE_TYPE_PASS_FAIL';
        case eaqAssignmentConstants.labels.assignmentGrades.gradedScored:
            return 'GRADE_TYPE_SCORED';
        default:
            return '';
    }
};
var getGradeValue = function (grade) {
    if (grade) {
        return grade === 'PASS' ? 'Pass' : 'Fail';
    }
    return '';
};
var getAssignmentGradeBasedOnGradeTypeAndScore = function (assignmentGradeType, grade, score) {
    var value;
    var sort;
    switch (assignmentGradeType) {
        case ASSIGNMENT_GRADES_TYPES.GRADED:
            value = getGradeValue(grade);
            sort = value;
            break;
        case ASSIGNMENT_GRADES_TYPES.GRADED_SCORED:
            value = "".concat(score || 0, "%");
            sort = score || 0;
            break;
        default:
            value = 'not graded';
            sort = value;
            break;
    }
    return { value: value, sort: sort };
};
var getMasteryAssignmentGoal = function (masteryLevel) {
    var roundedMasteryLevel = Math.floor(masteryLevel);
    if (roundedMasteryLevel < 1) {
        return 'MASTERY_PRE_NOVICE';
    }
    if (roundedMasteryLevel >= 1 && roundedMasteryLevel < 2) {
        return 'MASTERY_NOVICE';
    }
    if (roundedMasteryLevel >= 2 && roundedMasteryLevel < 3) {
        return 'MASTERY_INTERMEDIATE';
    }
    return 'MASTERY_PROFICIENT';
};
var getMasteryGoalText = function (assignmentGoal) { return getMasteryAssignmentGoal(assignmentGoal); };
var getNonMasteryAssignmentGoal = function (questionCount) {
    var roundedQuestionCount = Math.round(questionCount);
    return {
        questionCount: roundedQuestionCount,
        assignmentGoalText: roundedQuestionCount === 1 ? 'QUESTION' : 'QUESTIONS'
    };
};
var getAssignmentGoal = function (assignmentType, assignmentGoals) {
    if (assignmentGoals === void 0) { assignmentGoals = []; }
    if (assignmentType === eaqConstants.assignmentType.mastery) {
        return {
            goal: getMasteryAssignmentGoal(assignmentGoals[0].goal)
        };
    }
    var _a = getNonMasteryAssignmentGoal(assignmentGoals[0].goal), questionCount = _a.questionCount, assignmentGoalText = _a.assignmentGoalText;
    return {
        questionCount: questionCount,
        assignmentGoalText: assignmentGoalText,
        goal: "".concat(questionCount, " ").concat(assignmentGoalText)
    };
};
var transformAssignmentStatus = function (assignmentStatus) {
    var isPastDue = false;
    var status;
    switch (assignmentStatus) {
        case 'PAST_DUE':
            isPastDue = true;
            status = 'Past due';
            break;
        case 'COMPLETED':
            status = 'Completed';
            break;
        case 'IN_PROGRESS':
            status = 'In progress';
            break;
        default:
            status = 'Not started';
    }
    return { isPastDue: isPastDue, status: status };
};
var remapFieldsForEngagementReport = function (item, avgTimeOfClassOnQuestions, isEAQAssignmentType) {
    var _a;
    var avgTimePerQuestionDuration = isEAQAssignmentType ? moment.duration(item.avgTimeSpentOnQuestions) : moment.duration(item.avgTimeSpent);
    var avgTimeSpentCompareToClassAvg = moment.duration(avgTimePerQuestionDuration).subtract(avgTimeOfClassOnQuestions);
    return {
        studentId: item.userId,
        studentName: getStudentUserFullName(item),
        percentAvgScore: +item.percentAvgScore || 0,
        performanceComparedToClassAvg: +item.avgScore || 0,
        numberOfAssignedQuestionsAttempted: item.totalAssignmentQuestionsAnswered,
        numberOfSelfStudyQuestionsAttempted: item.totalSelfStudyQuestionsAnswered,
        avgScore: item.avgScore,
        totalGradePoints: item.totalGradePoints || 0,
        totalScore: item.totalScore || 0,
        avgTimePerQuestionSeconds: avgTimePerQuestionDuration.asSeconds(),
        avgTimePerQuestionComparedToClassAvgSeconds: avgTimeSpentCompareToClassAvg.asSeconds(),
        pastDue: item.totalAssignmentsPastDue,
        avgTimeSpent: item.avgTimeSpent ? moment.duration(item.avgTimeSpent).asSeconds() : null,
        totalLogins: (_a = item.totalLogins) !== null && _a !== void 0 ? _a : 0,
        lastLogin: item.lastLogin,
        totalTimeSpentOnSelfStudySeconds: moment.duration(item.totalTimeSpentOnSelfStudy).asSeconds(),
        totalAssignmentsBelowClassAvg: item.totalAssignmentsBelowClassAvg,
        isAtRiskStudent: item.isAtRiskStudent
    };
};
var remapFieldsForAssignmentEngagementTable = function (assignmentEngagement) {
    var assignmentId = assignmentEngagement.assignmentId, assignmentName = assignmentEngagement.assignmentName, percentComplete = assignmentEngagement.percentComplete, assignmentGradeType = assignmentEngagement.assignmentGradeType, avgScore = assignmentEngagement.avgScore, avgTimeSpent = assignmentEngagement.avgTimeSpent, avgTimeSpentPerQuestion = assignmentEngagement.avgTimeSpentPerQuestion, dueDate = assignmentEngagement.dueDate, assignmentType = assignmentEngagement.assignmentType, avgQuestionsAnsweredCorrect = assignmentEngagement.avgQuestionsAnsweredCorrect, avgQuestionsAnsweredIncorrect = assignmentEngagement.avgQuestionsAnsweredIncorrect;
    var isEAQAssignmentType = ASSIGNMENT_TYPES[assignmentType].group === ASSIGNMENT_TYPE_GROUPS.EAQ;
    var classAvgTimeSpentValue = isEAQAssignmentType ? avgTimeSpentPerQuestion : avgTimeSpent;
    var classAvgTimeSpentDuration = moment.duration(classAvgTimeSpentValue);
    var numberOfAvgQuestionAttempt = (avgQuestionsAnsweredCorrect || 0) + (avgQuestionsAnsweredIncorrect || 0);
    return {
        id: assignmentId,
        name: assignmentName,
        percentCompletion: +percentComplete || 0,
        scoringType: assignmentGradeType,
        classAvgScore: +avgScore || 0,
        numberOfAvgQuestionAttempt: +numberOfAvgQuestionAttempt.toFixed(2),
        classAvgTimeSpentSeconds: classAvgTimeSpentDuration.asSeconds(),
        dueDate: dueDate,
        assignmentType: assignmentType
    };
};
var remapFieldsForAssignmentDetailReport = function (item, assignmentGradeType) {
    var user = item.eolsUserDto;
    var metrics = item.questionCount;
    var timeSpent = Math.floor(item.timeSpent);
    var score = Math.floor(item.score * 100);
    var grade = getAssignmentGradeBasedOnGradeTypeAndScore(assignmentGradeType, item.grade, score);
    return __assign({ name: "".concat(user.lastName, ", ").concat(user.firstName), nameSort: user.lastName.toLowerCase(), studentId: user.id, dateSubmitted: item.submitTime ? moment.utc(item.submitTime).local().format(DATE_FORMATS.DEFAULT) : VALUE_NA, grade: grade.value, gradeSort: grade.sort, timeSpent: asTimestring(timeSpent), timeSpentSort: timeSpent, countOfCorrectAnswers: metrics.totalCorrectAnswered, countOfIncorrectAnswers: metrics.totalIncorrectAnswered }, transformAssignmentStatus(item.status));
};
var remapFieldsForAssignmentInfo = function (assignmentData) {
    if (!assignmentData) {
        return {};
    }
    var id = assignmentData.id, assignmentGoals = assignmentData.assignmentGoals, assignmentTopics = assignmentData.assignmentTopics, title = assignmentData.title, dueDate = assignmentData.dueDate, assignmentGradeType = assignmentData.assignmentGradeType, assignmentType = assignmentData.assignmentType;
    return __assign({ id: id, assignmentType: assignmentType, dueDate: dueDate ? moment.utc(dueDate).local().format(DATE_FORMATS.LOCALE) : NO_DUE_DATE, gradeType: getGradeTypeDisplayName(assignmentGradeType), title: title, topics: (assignmentTopics || []).map(function (item) { return item.text; }).join('; '), type: getAssignmentTypeTranslateText(assignmentType) }, getAssignmentGoal(assignmentType, assignmentGoals));
};
var fetchAssignmentInfo = function (assignmentId) {
    if (assignmentId) {
        return facadeApi.get("/eaq/assignment/".concat(assignmentId));
    }
    return Promise.resolve({});
};
var fetchAssignmentDetail = function (assignmentId) {
    if (assignmentId) {
        return facadeApi.get("/eaq/assignmentDetail/".concat(assignmentId));
    }
    return Promise.resolve([]);
};
var fetchStudentEngagements = function (courseId, assignmentType) {
    if (!courseId) {
        return Promise.resolve({ data: {} });
    }
    var contentTypeQuery = assignmentType != null ? "&contentType=".concat(assignmentType) : '';
    return facadeApi.get("/performancereport/studentengagement/reportV2?courseSectionId=".concat(courseId).concat(contentTypeQuery));
};
var fetchAssignmentEngagements = function (courseId, assignmentType) {
    if (!courseId) {
        return Promise.resolve({ data: {} });
    }
    var contentTypeQuery = assignmentType ? "&contentType=".concat(assignmentType) : '';
    return facadeApi.get("/performancereport/assignmentEngagement/reportV2?courseSectionId=".concat(courseId).concat(contentTypeQuery));
};
var fetchStudentDetailReport = function (courseSectionId, studentId) {
    if (!courseSectionId || !studentId) {
        return Promise.resolve({ data: {} });
    }
    return facadeApi.get("/gradebook/studentdetail/courseSection/".concat(courseSectionId, "/student/").concat(studentId));
};
var fetchGrabookStudentDetailReport = function (courseSectionId) {
    if (!courseSectionId) {
        return Promise.resolve({ data: [{}] });
    }
    return perFacadeApi.get("/gradebook/studentdetail/courseSection/".concat(courseSectionId));
};
var fetchEAQAssignmentPerformance = function (courseSectionId) {
    if (!courseSectionId) {
        return Promise.resolve({ data: [] });
    }
    return facadeApi.get("/eaq/assignmentPerformance?courseSectionId=".concat(courseSectionId));
};
var fetchCourseSectionRoles = function (userId) { return facadeApi.get("v1/eolsUser/".concat(userId, "/courseSection/roles")); };
var fetchEAQFeatures = function () { return facadeApi.get("/features/app/EAQ"); };
var fetchGradebookData = function (courseSectionId, attemptType, studentLimit) {
    if (studentLimit === void 0) { studentLimit = 1000; }
    if (!courseSectionId) {
        return Promise.resolve({ data: {} });
    }
    return perFacadeApi.get("/gradebook/courseSection/".concat(courseSectionId, "?attemptType=").concat(attemptType, "&studentLimit=").concat(studentLimit));
};
var fetchGradebookDataInExcel = function (courseSectionId, attemptType, studentLimit) {
    if (studentLimit === void 0) { studentLimit = 1000; }
    var timezone = encodeURIComponent(getTimeZone());
    return perFacadeApi.get("/gradebook/export/courseSection/".concat(courseSectionId, "?attemptType=").concat(attemptType, "&studentLimit=").concat(studentLimit, "&timeZone=").concat(timezone), {
        responseType: 'arraybuffer',
        data: null,
        headers: {
            'Content-Type': 'blob'
        }
    });
};
var fetchDashboardProgressing = function (courseSectionId) {
    if (!courseSectionId) {
        return Promise.resolve({ data: {} });
    }
    return perFacadeApi.get("/courseware/performanceEngagement/report?courseSectionId=".concat(courseSectionId));
};
var fetchAssignmentSummary = function (courseSectionId, contentType) {
    if (!courseSectionId) {
        return Promise.resolve({
            data: { metrics: [], card: null }
        });
    }
    var contentTypeQuery = contentType ? "&contentType=".concat(contentType) : '';
    return facadeApi.get("/performancereport/assignmentSummaryV2?courseSectionId=".concat(courseSectionId).concat(contentTypeQuery));
};
var fetchCWCourseList = function (isActive, isHideClassicCourse) {
    var baseUrl = "/courseSections";
    var params = new URLSearchParams();
    if (!isNil(isActive)) {
        params.append('isActive', isActive.toString());
    }
    if (!isNil(isHideClassicCourse)) {
        params.append('isHideClassicCourse', isHideClassicCourse.toString());
    }
    return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
};
var fetchCourseAggregateData = function (courseSectionId, instructorId) { return __awaiter(void 0, void 0, Promise, function () {
    var baseUrl, params, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baseUrl = '/v2/courseware/courseAggregation';
                params = new URLSearchParams();
                if (!(courseSectionId && instructorId)) return [3 /*break*/, 4];
                params.append('courseSectionId', String(courseSectionId));
                params.append('instructorId', String(instructorId));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, perFacadeApi.get("".concat(baseUrl, "?").concat(params))];
            case 2:
                data = (_a.sent()).data;
                return [2 /*return*/, Promise.resolve({ data: data })];
            case 3:
                error_1 = _a.sent();
                return [2 /*return*/, Promise.resolve({
                        data: [
                            {
                                courseSectionId: courseSectionId,
                                isEmpty: true
                            }
                        ]
                    })];
            case 4: return [2 /*return*/, Promise.resolve({ data: [] })];
        }
    });
}); };
var fetchCWCourseListByInstructor = function (instructorId) {
    var baseUrl = '/v2/courseSections';
    var params = new URLSearchParams();
    if (instructorId) {
        params.append('instructorId', String(instructorId));
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
    }
    return Promise.reject();
};
var fetchInstructorCourses = function (instructors) { return __awaiter(void 0, void 0, Promise, function () {
    var courseList, courseMap, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Promise.allSettled(instructors.map(fetchCWCourseListByInstructor))];
            case 1:
                courseList = _a.sent();
                if (courseList.some(function (v) { return v.status === 'rejected'; })) {
                    return [2 /*return*/, Promise.reject()];
                }
                courseMap = courseList.reduce(function (acc, curr, index) {
                    var currentData = curr.status === FULFILLED_STATUS ? curr.value.data : [];
                    var remapCourses = currentData.map(function (v) { return (__assign(__assign({}, remapCourseSection(v)), { instructorId: instructors[index] })); });
                    return __spreadArray(__spreadArray([], acc, true), remapCourses, true);
                }, []);
                return [2 /*return*/, Promise.resolve({ data: courseMap })];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, Promise.reject(error_2)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var fetchInstructorAllCourseAggregates = function (instructorIds) { return __awaiter(void 0, void 0, void 0, function () {
    var fetchList, allCourseAggregates, remapCourseAggregates, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(instructorIds === null || instructorIds === void 0 ? void 0 : instructorIds.length)) {
                    return [2 /*return*/, Promise.resolve({ data: [] })];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                fetchList = instructorIds.map(fetchAllCourseAggregations);
                return [4 /*yield*/, Promise.allSettled(fetchList)];
            case 2:
                allCourseAggregates = _a.sent();
                remapCourseAggregates = (allCourseAggregates || []).reduce(function (acc, curr) {
                    var _a, _b;
                    var data = curr.status === FULFILLED_STATUS ? (_b = (_a = curr.value) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.content : [];
                    return __spreadArray(__spreadArray([], acc, true), (data || []), true);
                }, []);
                return [2 /*return*/, Promise.resolve({ data: remapCourseAggregates })];
            case 3:
                error_3 = _a.sent();
                return [2 /*return*/, Promise.resolve({ data: [] })];
            case 4: return [2 /*return*/];
        }
    });
}); };
var fetchCourseAggregateByCourseSections = function (courseSections) { return __awaiter(void 0, void 0, void 0, function () {
    var courseMap_1, courseAggregatePromises, courseAggregates, remapCourseAggregates, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                courseMap_1 = keyBy(courseSections, function (v) { return v.id || v.courseId; });
                courseAggregatePromises = courseSections.map(function (_a) {
                    var instructorId = _a.instructorId, id = _a.id, courseId = _a.courseId;
                    return fetchCourseAggregateData(Number(id || courseId), Number(instructorId));
                });
                return [4 /*yield*/, Promise.allSettled(courseAggregatePromises)];
            case 1:
                courseAggregates = _a.sent();
                remapCourseAggregates = courseAggregates.reduce(function (acc, curr) {
                    var data = curr.status === FULFILLED_STATUS ? curr.value.data : [];
                    var remapCourses = remapCourseAggregate(first(data), courseMap_1[first(data).courseSectionId]);
                    return __spreadArray(__spreadArray([], acc, true), [remapCourses], false);
                }, []);
                return [2 /*return*/, Promise.resolve({ data: remapCourseAggregates })];
            case 2:
                error_4 = _a.sent();
                ELSLoggingService.error('report.service', "Error while attempting to fetch fetchCourseAggregateByCourseSections, error: ".concat(error_4.message));
                return [2 /*return*/, Promise.resolve({ data: [] })];
            case 3: return [2 /*return*/];
        }
    });
}); };
var fetchCourseAggregates = function (instructorId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, eolsUserIdsByUserNameAndType_1, courseList, courseMap_2, courseAggregatePromises, courseAggregates, remapCourseAggregates, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                return [4 /*yield*/, fetchCrosswalkUser(String(instructorId), SystemType.EVOLVETYPE)];
            case 1:
                _a = (_b.sent()).data.eolsUserIdsByUserNameAndType, eolsUserIdsByUserNameAndType_1 = _a === void 0 ? [] : _a;
                return [4 /*yield*/, Promise.all(eolsUserIdsByUserNameAndType_1.map(fetchCWCourseListByInstructor))];
            case 2:
                courseList = _b.sent();
                courseMap_2 = courseList === null || courseList === void 0 ? void 0 : courseList.reduce(function (acc, curr, index) {
                    var remapCourses = curr.data.map(function (v) { return (__assign(__assign({}, v), { instructorId: eolsUserIdsByUserNameAndType_1[index] })); });
                    return __assign(__assign({}, acc), keyBy(remapCourses, function (v) { return v.id || v.courseId; }));
                }, []);
                courseAggregatePromises = mapValues(courseMap_2, function (course) { return fetchCourseAggregateData(course.id || course.courseId, course.instructorId); });
                return [4 /*yield*/, Promise.all(Object.values(courseAggregatePromises))];
            case 3:
                courseAggregates = _b.sent();
                remapCourseAggregates = courseAggregates.reduce(function (acc, curr) {
                    var data = curr.data;
                    var remapCourses = remapCourseAggregate(first(data), courseMap_2[first(data).courseSectionId]);
                    return __spreadArray(__spreadArray([], acc, true), [remapCourses], false);
                }, []);
                return [2 /*return*/, Promise.resolve({ data: remapCourseAggregates })];
            case 4:
                err_1 = _b.sent();
                ELSLoggingService.error('report.service', "Error while attempting to fetch CourseAggregates, error: ".concat(err_1.message));
                return [2 /*return*/, Promise.resolve({ data: [] })];
            case 5: return [2 /*return*/];
        }
    });
}); };
var fetchCourseAggregate = function (courseSectionIds) { return __awaiter(void 0, void 0, Promise, function () {
    var uniqueCourseSectionIds, result, timezone, fetchCourseSectionData, fetchPromises;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(courseSectionIds === null || courseSectionIds === void 0 ? void 0 : courseSectionIds.length)) {
                    return [2 /*return*/, Promise.resolve([])];
                }
                uniqueCourseSectionIds = courseSectionIds.filter(function (value, index, array) {
                    return array.indexOf(value) === index;
                });
                result = [];
                timezone = "tz=".concat(encodeURIComponent(getTimeZone()));
                fetchCourseSectionData = function (courseId) { return __awaiter(void 0, void 0, void 0, function () {
                    var data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, perFacadeApi.get("/courseware/courseAggregation?courseSectionIds=".concat(courseId, "&").concat(timezone))];
                            case 1:
                                data = (_a.sent()).data;
                                if (data.length) {
                                    result.push.apply(result, data);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                fetchPromises = uniqueCourseSectionIds.map(fetchCourseSectionData);
                return [4 /*yield*/, Promise.all(fetchPromises)];
            case 1:
                _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
var fetchStudentHomeReport = function (userId, courseSectionId, eaqISBN) {
    if (userId && courseSectionId && eaqISBN) {
        return perFacadeApi.get("/studenthome/report?userId=".concat(userId, "&courseSectionId=").concat(courseSectionId, "&eaqISBN=").concat(eaqISBN));
    }
    return Promise.resolve({ data: {} });
};
var fetchEngagementSummary = function (courseSectionId) {
    if (!courseSectionId) {
        return Promise.resolve({ data: {} });
    }
    return perFacadeApi.get("/engagementSummary/reportV2?courseSectionId=".concat(courseSectionId));
};
var isEnabledGlobally = function (featureItems) {
    return JSON.parse((featureItems.find(function (item) { return ['ALL', null].includes(item.group); }) || {
        featureValue: 'false'
    }).featureValue);
};
var isEnabledAtGroupLevel = function (featureItems, groupValue) {
    return JSON.parse((featureItems.find(function (item) { return item.group === groupValue.toString(); }) || {
        featureValue: 'false'
    }).featureValue);
};
var isEnabled = function (feature, groupValue, eaqFeatures) {
    var featureItems = eaqFeatures.filter(function (item) { return item.featureName === feature.featureName; });
    var isFeatureEnabledGlobally = isEnabledGlobally(featureItems);
    if (groupValue) {
        return isFeatureEnabledGlobally || isEnabledAtGroupLevel(featureItems, groupValue);
    }
    return isFeatureEnabledGlobally;
};
var isFeatureEnabled = function (feature, currentCourseId, eaqFeatures) {
    if (currentCourseId) {
        return isEnabled(feature, currentCourseId, eaqFeatures);
    }
    return false;
};
var fetchCWAssignmentByCourseSectionId = function (courseSectionId) {
    var baseUrl = '/v2/assignment';
    var params = new URLSearchParams();
    if (courseSectionId) {
        params.append('courseSectionId', String(courseSectionId));
        return facadeApi.get("".concat(baseUrl, "?").concat(params));
    }
    return Promise.resolve({ data: [] });
};
var fetchStudentHomeAssignmentsReport = function (userId, courseSectionId) {
    if (userId && courseSectionId) {
        return perFacadeApi.get("/studenthome/report/assignments?userId=".concat(userId, "&courseSectionId=").concat(courseSectionId));
    }
    return Promise.resolve({ data: [] });
};
var fetchAssessmentExamDetail = function (cohortId, examId) {
    return perFacadeApi.get("/assessmentSummary/examDetail?cohortId=".concat(cohortId, "&examId=").concat(examId));
};
var fetchAssessmentStudentDetail = function (evolveUsername, programId) {
    return perFacadeApi.get("/assessmentSummary/studentDetail?evolveUsername=".concat(encodeURIComponent(evolveUsername), "&programId=").concat(programId));
};
var fetchAssessmentPerfDistribution = function (cohortId) {
    return perFacadeApi.get("/assessmentSummary/performanceDistribution?cohortId=".concat(cohortId));
};
export { asTimestamp, asTimestring, asTimestringFormated, convertNegativeDuration, displayNumberWithSign, durationAsTimestring, fetchAssessmentStudentDetail, fetchAssignmentDetail, fetchAssignmentEngagements, fetchAssignmentInfo, fetchAssignmentSummary, fetchCourseAggregate, fetchCourseAggregateByCourseSections, fetchCourseAggregateData, fetchCourseAggregates, fetchCourseSectionRoles, fetchCWAssignmentByCourseSectionId, fetchCWCourseList, fetchCWCourseListByInstructor, fetchDashboardProgressing, fetchEAQAssignmentPerformance, fetchEAQFeatures, fetchEngagementSummary, fetchGrabookStudentDetailReport, fetchGradebookData, fetchGradebookDataInExcel, fetchInstructorAllCourseAggregates, fetchInstructorCourses, fetchStudentDetailReport, fetchStudentEngagements, fetchStudentHomeAssignmentsReport, fetchStudentHomeReport, getAssignmentGradeBasedOnGradeTypeAndScore, getAssignmentTypeTranslateText, getAvgStudentsAchievedMastery, getGradeTypeDisplayName, getGradeValue, getMasteryAssignmentGoal, getMasteryGoalText, getNonMasteryAssignmentGoal, isFeatureEnabled, remapFieldsForAssignmentDetailReport, remapFieldsForAssignmentEngagementTable, remapFieldsForAssignmentInfo, remapFieldsForEngagementReport, transformAssignmentStatus, fetchAssessmentExamDetail, fetchAssessmentPerfDistribution };
